import { useState, useEffect, useCallback } from "react";
import { useTranslation } from "react-i18next";
import styles from "./Hero.module.css";
import img1 from "../../../assets/images/hero-carousel/team-discussion-office-desk.webp";
import img2 from "../../../assets/images/hero-carousel/business-consultation-office.webp";
import img3 from "../../../assets/images/hero-carousel/dev-working-project-laptop.webp";
import { useNavigate } from "react-router-dom";
import Button from "../../UI/Button/Button";

const SLIDES = [
  { src: img1, alt: "Echipa Softindex – dezvoltare software" },
  { src: img2, alt: "Meeting Softindex – consultanță IT" },
  { src: img3, alt: "Programare Softindex – soluții digitale" },
];

const INTERVAL = 5000;

export default function Hero() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [active, setActive] = useState(0);

  const next = useCallback(() => {
    setActive(i => (i + 1) % SLIDES.length);
  }, []);

  useEffect(() => {
    const id = setInterval(next, INTERVAL);
    return () => clearInterval(id);
  }, [next]);

  const scrollToServices = () => {
    document.getElementById("company-services")?.scrollIntoView({
      behavior: "smooth",
    });
  };

  return (
    <section id="hero" className={styles.hero}>
      <div className={styles.media}>
        {SLIDES.map((slide, i) => (
          <img
            key={i}
            src={slide.src}
            alt={slide.alt}
            className={`${styles.carouselSlide} ${i === active ? styles.carouselSlideActive : ""}`}
            width={1920}
            height={1080}
            decoding={i === 0 ? "sync" : "async"}
            fetchPriority={i === 0 ? "high" : "low"}
          />
        ))}
        <div className={styles.overlay} aria-hidden />
        <div className={styles.mesh} aria-hidden />
      </div>

      <div className={styles.inner}>
        <div className={styles.container}>
          <h1 className={styles.title}>
            {t("hero.title")}{" "}
            <span className={styles.highlight}>{t("hero.titleHighlight")}</span>
          </h1>
          <p className={styles.lead}>{t("hero.description")}</p>
          <div className={styles.buttons}>
            <Button
              className={styles.ctaPrimary}
              onClick={() => navigate("/contact")}
            >
              {t("hero.getQuoteButton")}
            </Button>
            <Button variant="ghostLight" onClick={scrollToServices}>
              {t("hero.learnMoreButton")}
            </Button>
          </div>
        </div>
      </div>

      <div className={styles.dots}>
        {SLIDES.map((_, i) => (
          <button
            key={i}
            className={`${styles.dot} ${i === active ? styles.dotActive : ""}`}
            onClick={() => setActive(i)}
            aria-label={`Slide ${i + 1}`}
            aria-current={i === active ? "true" : undefined}
          />
        ))}
      </div>
    </section>
  );
}
